module.exports = __webpack_public_path__ + "static/media/chart.72bbb457.svg";